<div class="layout-container">

    <main class="about-content">
        <header>
            <h1>Mind Link: Il Miglior Gioco di Intesa Vincente Online</h1>
            <h2>L'app gratuita per allenarsi a Reazione a Catena e divertirsi in squadra</h2>
            <p>Benvenuto su <strong>Mind Link</strong>, l'app definitiva per giocare all'<strong>Intesa Vincente</strong> con i tuoi amici. Se sei un fan del programma TV <em>Reazione a Catena</em> o cerchi un gioco di parole a squadre per animare le tue serate, sei nel posto giusto.</p>
        </header>

        <button (click)="goToGame()" class="action-button primary">Gioca ora</button>

        <section>
            <h3>Cos'è Mind Link?</h3>
            <p>Mind Link è un gioco di parole intuitivo e veloce, progettato per simulare le emozioni dell'<strong>Intesa Vincente</strong>, il famoso gioco finale di <em>Reazione a Catena</em>. Disponibile gratuitamente come Web App, Mind Link trasforma il tuo smartphone in un tabellone di gioco professionale.</p>
            <p>Non serve scaricare nulla: Mind Link è una <strong>PWA (Progressive Web App)</strong>. Questo significa che puoi giocare direttamente dal browser o installarla sulla home screen del tuo telefono in pochi secondi, risparmiando memoria.</p>
        </section>

        <section>
            <h3>Come si gioca all'Intesa Vincente su Mind Link</h3>
            <p>Le regole sono semplici ma la sfida è alta. Mind Link riprende fedelmente le meccaniche che hanno reso celebre il gioco in TV.</p>
            
            <article>
                <h4>Le Squadre</h4>
                <p>Il gioco richiede almeno <strong>3 giocatori</strong> per squadra. I ruoli sono divisi in:</p>
                <ul>
                    <li><strong>I Prompters (2 giocatori):</strong> Devono formulare una domanda di senso compiuto alternandosi nel dire una sola parola a testa. L'obiettivo è far indovinare una parola segreta al terzo compagno.</li>
                    <li><strong>Il Leader (1 giocatore):</strong> Deve capire la domanda formulata dai compagni e dare la risposta corretta (la parola segreta) nel minor tempo possibile.</li>
                </ul>
                Per semplificare il gioco, nell'app basta un cellulare per entrambi i Prompters.
            </article>

            <article>
                <h4>Svolgimento del Gioco</h4>
                <ol>
                    <li>Il Leader avvia il timer su Mind Link.</li>
                    <li>L'app mostra la <strong>parola misteriosa</strong> solo ai Prompters. <i>Nota: In Mind Link, il flusso è ottimizzato per gestire le parole e i tempi automaticamente.</i></li>
                    <li>I Prompters iniziano a parlare. Esempio:
                        <br><em>Giocatore A:</em> "Quale"
                        <br><em>Giocatore B:</em> "animale"
                        <br><em>Giocatore A:</em> "ha"
                        <br><em>Giocatore B:</em> "la"
                        <br><em>Giocatore A:</em> "proboscite?"
                    </li>
                    <li>Il Leader risponde: "elefante!". Se la risposta è corretta, si guadagna un punto.</li>
                    <li>Se i Prompters si bloccano o sbagliano la sintassi, possono usare un <strong>Passo</strong> per cambiare parola senza penalità (fino a un massimo di 3 per partita).</li>
                </ol>
            </article>
        </section>

        <section>
            <h3>Meccaniche di Gioco: Passi e Raddoppi</h3>
            <p>Per rendere la sfida ancora più avvincente, Mind Link include le meccaniche strategiche tipiche dei migliori giochi di parole a squadre.</p>
            
            <article>
                <h4>I Passi (Max 3)</h4>
                <p>Ogni squadra ha a disposizione <strong>3 passi</strong> per ogni partita. Il "Passo" è fondamentale quando la parola misteriosa è troppo complessa o quando i Prompters non riescono a trovare una sintassi efficace. Usare un passo permette di passare alla parola successiva senza perdere secondi preziosi nel tentativo di formulare una domanda impossibile.</p>
            </article>

            <article>
                <h4>I Raddoppi (Max 2)</h4>
                <p>La vera strategia si vede nei <strong>Raddoppi</strong>. Ogni squadra può richiedere fino a <strong>2 raddoppi</strong> durante il gioco, che consente di totalizzare ben <strong>2 punti</strong> in un round. 
                Il raddoppio permette di giocare una manche speciale con termini formati da almeno 2 parole, permettendo di dare una svolta decisiva al punteggio finale.</p>
                <p>Saper gestire il raddoppio è la chiave per vincere l'Intesa Vincente nelle fasi finali del gioco!</p>
            </article>
        </section>

        <section>
            <h3>Perché usare Mind Link per le tue serate giochi?</h3>
            <p>Organizzare una partita a <em>Reazione a Catena</em> in casa può essere difficile senza gli strumenti giusti. Mind Link risolve tutti i problemi logistici:</p>
            <ul>
                <li><strong>Timer Integrato:</strong> Non serve un cronometro esterno. Mind Link gestisce il conto alla rovescia per rendere la sfida adrenalinica.</li>
                <li><strong>Database di Parole:</strong> Migliaia di parole da indovinare, per non restare mai senza idee.</li>
                <li><strong>Punteggio Automatico:</strong> Tieni traccia dei punti senza carta e penna.</li>
                <li><strong>L'esperienza Ludico:</strong> Mind Link fa parte dell'ecosistema <strong>Ludico</strong>, la piattaforma per giochi da tavolo digitali moderna e veloce.</li>
            </ul>
        </section>

        <section>
            <h3>Allenamento per Reazione a Catena</h3>
            <p>Sogni di partecipare al programma TV? L'<strong>Intesa Vincente</strong> è il gioco dove si decide la vittoria. Mind Link è lo strumento perfetto per:</p>
            <ul>
                <li>Migliorare il <strong>ritmo</strong> di squadra.</li>
                <li>Allenare la <strong>sintassi</strong> veloce.</li>
                <li>Sviluppare telepatia e intesa con i tuoi compagni.</li>
                <li>Imparare a gestire i <strong>raddoppi</strong> e i momenti di tensione.</li>
            </ul>
            <p>Molti campioni di <em>Reazione a Catena</em> si allenano per mesi simulando il gioco a casa. Con Mind Link, hai un simulatore professionale sempre in tasca.</p>
        </section>

        <section>
            <h3>Strategie per Vincere all'Intesa Vincente</h3>
            <p>Vuoi diventare imbattibile a Mind Link? Ecco alcuni consigli da pro:</p>
            <p><strong>1. Sii Conciso:</strong> Non usare parole inutili. Invece di "Quale è l'animale che...", dite "Quale animale con proboscide?".</p>
            <p><strong>2. Ritmo Costante:</strong> Mantenete un ritmo tipo metronomo. Esitare rompe la concentrazione del Leader.</p>
            <p><strong>3. Accordi Preliminari:</strong> Stabilite convenzioni. Ad esempio, se la parola è un verbo, iniziate sempre con "Quale azione...".</p>
            <p><strong>4. Usate i Passi Saggiamente:</strong> Non sprecate i 3 passi subito, ma non restate bloccati su una parola difficile per più di 10 secondi.</p>
            <p><strong>5. Il Momento del Raddoppio:</strong> Giocate il raddoppio quando sentite che la vostra intesa è al massimo. Ricordate che dovete avere almeno 2 punti per poterlo attivare.</p>
        </section>

        <section>
            <h3>Domande Frequenti (FAQ) su Mind Link e Intesa Vincente</h3>
            
            <article>
                <h4>Esiste un'app per l'Intesa Vincente gratis?</h4>
                <p>Sì, <strong>Mind Link</strong> è completamente gratuita. È accessibile da qualsiasi browser (Chrome, Safari, Firefox) e funziona su Android e iOS come un'app nativa.</p>
            </article>

            <article>
                <h4>Come posso allenarmi per Reazione a Catena?</h4>
                <p>Il modo migliore è giocare regolarmente con la tua squadra. Usate Mind Link per simulare le manche del gioco televisivo, cronometrando le risposte e cercando di superare il vostro record di parole indovinate.</p>
            </article>

            <article>
                <h4>Cosa significa "Intesa Vincente"?</h4>
                <p>È il gioco finale di <em>Reazione a Catena</em>, dove l'intesa tra i concorrenti è fondamentale. Vince la squadra che indovina più parole nel tempo stabilito costruendo domande perfette.</p>
            </article>

            <article>
                <h4>Mind Link è l'app ufficiale della RAI?</h4>
                <p>No, Mind Link è un gioco indipendente ispirato alle meccaniche dell'Intesa Vincente. È creato da fan per fan, per permettere a tutti di giocare a casa.</p>
            </article>

            <article>
                <h4>Quali sono i migliori giochi di parole a squadre?</h4>
                <p>Oltre a Mind Link, esistono classici come Taboo o Pictionary, ma Mind Link è unico perché si focalizza sulla costruzione sintattica della frase, rendendolo un esercizio mentale eccellente e un party game divertentissimo.</p>
            </article>

            <article>
                <h4>Posso giocare a Mind Link offline?</h4>
                <p>No, Mind Link si basa necessariamente sulla connessione internet per sincronizzare l'app del Leader a quella del Prompter.</p>
            </article>
        </section>

        <section>
            <h3>Ludico: La Tua Sala Giochi Digitale</h3>
            <p><strong>Mind Link</strong> è solo l'inizio. <strong>Ludico</strong> è la piattaforma che raccoglie i migliori giochi da tavolo e di società in formato digitale. L'obiettivo di Ludico App è portare il divertimento dei giochi in scatola sul tuo smartphone, eliminando il bisogno di tabelloni ingombranti, dadi persi o clessidre rotte.</p>
            <p>Che tu stia cercando <em>giochi tipo Reazione a Catena</em>, quiz, o giochi di strategia, Ludico è la tua destinazione.</p>
        </section>

        <button (click)="goToGame()" class="action-button primary">Gioca ora</button>

        <div class="separator"></div>

        <footer>
            <small>
                <p><strong>Disclaimer Legale:</strong> Mind Link e Ludico non sono affiliati con RAI, Endemol Shine Italy o il programma televisivo "Reazione a Catena". "Intesa Vincente" e "Reazione a Catena" sono marchi registrati dei rispettivi proprietari. Questo gioco è un omaggio non ufficiale creato a scopo ludico e didattico, ispirato alle meccaniche di gioco popolari.</p>
                <p>Mind Link - Il gioco di parole che mette alla prova la tua intesa. Gioca ora su Ludico App.</p>
            </small>
        </footer>
    </main>

</div>
